module.exports = __webpack_public_path__ + "static/media/8-jan16march16.a8087f3c.pdf";